import type { FaireProductEntity } from "../../entity_types/product";

export const plant_dyed_7: FaireProductEntity = {
  token: "plant-dyed-7",
  type: "product",
  name: "Turkana Handwoven Ethiopian Cotton",
  brandName: "Sabahar",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/c7082c923108f1cc7acab31586f909fcd66a69fd2e9285fc9bbede5f765c81e2.png",
  priceDollars: 19,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/c7082c923108f1cc7acab31586f909fcd66a69fd2e9285fc9bbede5f765c81e2.png",
  weight: 0.8,
  dimensions: {
    width: 20,
    height: 30,
    depth: 1,
  },
  description: "Handwoven Ethiopian cotton with plant-dyed colors",
  categoryTokens: ["cat_accessories"],
  tags: [
    "plant-dyed",
    "natural-dye",
    "sustainable-textiles",
    "handwoven",
    "cotton",
    "ethiopian",
    "premium",
  ],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
